<template>
  <div :class="classModifiers" @pointerenter="onPointerEnter" @pointerleave="onPointerLeave">
    <preview-carousel-loader v-if="!isComponentReady"></preview-carousel-loader>
    <div v-show="showNav" :class="tabsClassModifiers">
      <button
        v-if="showNavigationArrows"
        class="preview-carousel__arrow preview-carousel__arrow--left"
        @click="scrollLeft"
        :disabled="!canScrollLeft"
        aria-label="Scroll left"
      ></button>
      <div ref="tabsList" class="preview-carousel__nav-container">
        <tabs
          :items="navigationTabs"
          theme="carousel"
          @tabChange="navigationTabChange"
          :activeTab="activeTab"
          @click="tabsClicked"
        ></tabs>
      </div>
      <button
        v-if="showNavigationArrows"
        class="preview-carousel__arrow preview-carousel__arrow--right"
        @click="scrollRight"
        :disabled="!canScrollRight"
        aria-label="Scroll right"
      ></button>
    </div>
    <div
      :class="contentClassModifiers"
      :style="contentStyleModifiers"
      ref="content"
      v-show="isComponentReady"
    >
      <div
        class="preview-carousel__story"
        :data-cms-story-index="index"
        v-for="(data, index) in storyMap"
        :key="`${refreshIndex}-${index}`"
        v-show="parseInt(index, 10) === currentStoryIndex"
      >
        <div class="preview-carousel__story-html" v-html="storyContentMap[index]"></div>
      </div>
    </div>
    <div v-if="showExpandControl" :class="expandClassModifiers" @click="toggleExpand">
      <span v-if="!isExpanded">Read More &#9662;</span>
      <span v-else>Show Less &#9652;</span>
    </div>
  </div>
</template>

<script src="./preview-carousel.js"></script>
<style src="./preview-carousel.scss" lang="scss"></style>
